import React from "react";
import {
  Select,
  Checkbox,
  Table,
  Row,
  Col,
  Button,
  Space,
  DatePicker,
  Dropdown,
  Modal,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { DownOutlined } from "@ant-design/icons";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";
import VehicleStore from "../store/VehicleStore";
import dayjs from "dayjs";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import DetailedJobStore from "../store/DetailedJobReportStore";
import DriverLoginReportStore from "../store/DriverLoginReportStore";
import DailyJobReportStore from "../store/DailyJobReportStore";
const { RangePicker } = DatePicker;
let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
  });

  return arr;
};
const { Option } = Select;
class DailyJobReport extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    // this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.vehicleStore = new VehicleStore();
    this.detailedJobReportStore = new DetailedJobStore(this);
    this.driverLoginStore = new DriverLoginReportStore(this);
    this.dailyJobReportStore = new DailyJobReportStore(this);
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      selectedVehicles: [],
      selectedDrivers: [],
      selectAllVehicles: false,
      selectAllDrivers: false,
      showMonthPopup: false,
      filterby: "",
      data: "",
      companyId: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      Notcompany: false,
      Notasset: false,
      NotDriver: false,
      filterNotSelected: false,
      expandedRowKeys: [],
      loadedInvoiceData: {},
      selectAllStatus: false,
      status: "",
      innerGridData: [],
      filterValue: "",
      modalVisible: false,

      selectedColumns: widthAdderFunc([
        {
          title: context.translate("Sr No."),
          dataIndex: "sno",
          key: "sno",
          width: "10%",
        },
        {
          title: context.translate("_VEHICLE_NO_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          width: "10%",
        },
        {
          title: context.translate("_DRIVER_ID_"),
          dataIndex: "driverId",
          key: "driverId",
          width: "10%",
        },
        {
          title: context.translate(
            "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
          ),
          dataIndex: "name",
          key: "name",
        },
        {
          title: context.translate("_INVOICE_NO_"),
          dataIndex: "invoiceNo",
          key: "invoiceNo",
          width: "10%",
        },
        {
          title: context.translate("_DEPOSITOR_"),
          dataIndex: "depositor",
          key: "depositor",
          width: "10%",
        },
        {
          title: context.translate("_INVOICE_AMOUNT_"),
          dataIndex: "invoiceAmount",
          key: "invoiceAmount",
          width: "10%",
        },
        {
          title: context.translate("_QUANTITY_"),
          dataIndex: "quantity",
          key: "quantity",
          width: "10%",
        },
        {
          title: context.translate("_CUSTOMER_NAME_"),
          dataIndex: "customerName",
          key: "customerName",
          width: "10%",
        },
        {
          title: context.translate("_DELIVERY_STATUS_"),
          dataIndex: "deliveryStatus",
          key: "deliveryStatus",
          width: "10%",
        },
        {
          title: context.translate("_UNDELIVERED_REASON_"),
          dataIndex: "orderStatus",
          width: "12%",
        },
        {
          title: context.translate("_JOB_STARTED_TIME_"),
          dataIndex: "jobStartedTime",
          key: "jobStartedTime",
          width: "10%",
        },

        {
          title: context.translate("_JOB_FINISHED_TIME_"),
          dataIndex: "jobFinishedTime",
          key: "jobFinishedTime",
          width: "10%",
        },
        {
          title: context.translate("_FLEET_CREATEROUTE_ROUTEADD_TOTALTIME_"),
          dataIndex: "totalduration",
          key: "totalduration",
          width: "10%",
        },
        {
          title: context.translate("_TRAVEL_KM_"),
          dataIndex: "travelKm",
          key: "travelKm",
          width: "10%",
        },

        {
          title: context.translate("_NO_OF_ATTEMPTS_"),
          dataIndex: "attempt_number",
          width: "12%",
        },
      ]),
    };
    this.menuProps = {
      items: [
        {
          // label: "Excel",
          label: context.translate("_EXCEL_"),
          key: "excel",
        },

        {
          // label: "PDF",
          label: context.translate("_PDF_"),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        let result = [];

        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            filterBy: this.state.filterby,
            driverId: this.state.selectedDrivers,
            status: this.state.status,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
            language: null,
          };
          if (val.key == "excel") {
            this.dailyJobReportStore.exportExcel(getData);
          }
          if (val.key == "pdf") {
            this.dailyJobReportStore.exportpdf(getData);
          }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }

  async componentDidMount() {
    this.setState({ pageSize: 50 });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
    await this.setState({ column: this.state.selectedColumns });
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ companyId: comp?.value });
    await this.setState({
      selectedVehicles: [],
      selectAllVehicles: false,
      selectedDrivers: [],
      selectAllDrivers: false,
    });

    await this.vehicleStore.getDeliveryVehicles(comp?.value);

    await this.driverLoginStore.getDriversByCompanyId({
      companyId: comp?.value,
    });

    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    // this.handleSearch();
    await this.showData();
  }

  addMonths = (date, months) => {
    // date.setMonth(date.getMonth() + months);
    // date = date + months;
    var indx = dayjs().month() + -6;
    // return date.format("YYYY-MM-DD HH:mm:ss");
    return dayjs().month(indx);
  };
  checkFromDate(dates) {
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    }
  };

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (this.state.selectedDrivers.length === 0) {
      this.setState({ NotDriver: true });
    } else {
      this.setState({ NotDriver: false });
    }
    if (this.state.filterValue.length === 0) {
      console.log("filterValue");
      this.setState({ filterNotSelected: true });
    } else {
      this.setState({ filterNotSelected: false });
    }
    if (
      (this.state.companyId &&
        this.state.filterValue.length > 0 &&
        this.state.selectedDrivers.length > 0) ||
      (this.state.companyId &&
        this.state.filterValue.length > 0 &&
        this.state.selectedVehicles.length > 0)
      // (this.state.companyId )
      // &&
      // this.state.selectedVehicles.length > 0 &&
      // this.state.jobType.length > 0) ||
      // (this.state.companyId &&
      //
      //   this.state.jobType.length > 0
    ) {
      // this.setState({mandatory:false})
      this.setState({
        Notcompany: false,
        Notasset: false,
        NotDriver: false,
        filterNotSelected: false,
      });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.dailyJobReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          filterBy: this.state.filterby,
          vehicleId: this.state.selectedVehicles,
          driverId: this.state.selectedDrivers,
          status: this.state.status,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          pageNo: this.state.currentPage,
        });
        await this.setState({ loadData: 1 });
      }
    }
  };

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId?.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  handleAllSelectDriver = async (e) => {
    if (this.state.selectAllDrivers) {
      const allDrivers = this.driverLoginStore?.getDrivers?.map((val) => {
        return val.driverId;
      });
      await this.setState({ selectedDrivers: allDrivers });
    } else {
      await this.setState({ selectedDrivers: [] });
    }
  };

  render() {
    return (
      <>
        <div style={{ padding: 0 }}>
          <Row className="headerFixed">
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_DAILY_JOB_REPORT_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Dropdown
                  menu={this.menuProps}
                  disabled={
                    this.dailyJobReportStore?.detailedJobData?.length > 0
                      ? false
                      : true
                  }
                >
                  <Button
                    className="exportDropdown"
                    // style={{ backgroundColor: config.activeColor }}
                  >
                    <Space>
                      {this.context.translate("_EXPORT_")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>
        </div>
        <div
          style={{
            paddingTop: "10px",
            paddingRight: "24px",
            paddingLeft: "24px",
          }}
        >
          <Row className="listInputRow">
            <Col span={22}>
              <Space>
                <CompanyAutocomplete
                  onChange={this.handleChange}
                  allowClear={true}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />
                {this.props.getUserData().isadmin === 1 && (
                  <>
                    <DeviceGroupsForVehicles
                      vehicleStore={this.vehicleStore}
                      setLoadDta={() => this.setState({ loadData: 1 })}
                      resetVehicles={() =>
                        this.setState({
                          selectedVehicles: [],
                          selectAllVehicles: false,
                        })
                      }
                    />
                  </>
                )}

                <Select
                  style={{ width: 130 }}
                  status={this.state.filterNotSelected ? "error" : false}
                  // placeholder='Filter by'
                  placeholder={this.context.translate("_FILTER_BY_")}
                  onChange={(val) => {
                    this.setState({ filterValue: val });
                    this.setState({
                      filterby: val,
                      selectedDrivers: [],
                      selectedVehicles: [],
                      selectAllDrivers: false,
                      selectAllVehicles: false,
                    });
                  }}
                >
                  <Select.Option value="Driver">
                    {this.context.translate(
                      "_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"
                    )}
                  </Select.Option>

                  <Select.Option value="Vehicle">
                    {this.context.translate("_VEHICLES_")}
                  </Select.Option>
                </Select>
                {this.state.filterby == "Vehicle" && (
                  <>
                    <Checkbox
                      checked={this.state.selectAllVehicles}
                      onChange={async (e) => {
                        await this.setState({
                          selectAllVehicles: e.target.checked,
                        });
                        if (this.state.selectAllVehicles) {
                          await this.setState({
                            Notasset: false,
                          });
                        }
                        await this.handleAllSelectVehicles();
                      }}
                    />

                    {this.context.translate("_ALL_")}

                    <Select
                      maxTagCount="responsive"
                      value={this.state.selectedVehicles}
                      onChange={(val) => {
                        this.setState({ selectedVehicles: val });
                        if (
                          this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                          val.length
                        ) {
                          this.setState({ selectAllVehicles: false });
                        } else {
                          this.setState({ selectAllVehicles: true });
                        }

                        if (val?.length > 1) {
                          this.setState({ showAlertPopup: true });
                        }
                      }}
                      style={{ width: 180 }}
                      showSearch
                      status={this.state.Notasset ? "error" : false}
                      mode="multiple"
                      placeholder={this.context.translate(
                        "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                      )}
                      filterOption={(inputValue, option) => {
                        if (option.children) {
                          return (
                            option.children
                              .toLowerCase()
                              .indexOf(inputValue.toLowerCase()) >= 0
                          );
                        }
                      }}
                    >
                      {this.vehicleStore?.getVehiclesUsingCompanyId?.map(
                        (val) => {
                          return (
                            <Option value={val.vehicleId}>
                              {val.vehicleNo}
                            </Option>
                          );
                        }
                      )}
                    </Select>
                  </>
                )}
                {this.state.filterby == "Driver" && (
                  <>
                    <Checkbox
                      checked={this.state.selectAllDrivers}
                      onChange={async (e) => {
                        await this.setState({
                          selectAllDrivers: e.target.checked,
                        });

                        await this.handleAllSelectDriver();
                      }}
                    />

                    {this.context.translate("_ALL_")}
                    <Select
                      maxTagCount="responsive"
                      value={this.state.selectedDrivers}
                      onChange={(val) => {
                        this.setState({ selectedDrivers: val });
                        if (
                          this.driverLoginStore?.getDrivers?.length > val.length
                        ) {
                          this.setState({ selectAllDrivers: false });
                        } else {
                          this.setState({ selectAllDrivers: true });
                        }
                      }}
                      style={{ width: 180 }}
                      showSearch
                      status={this.state.NotDriver ? "error" : false}
                      mode="multiple"
                      placeholder={this.context.translate(
                        "_FLEET_DRIVER_DRIVERLIST_DRIVERNAME_"
                      )}
                      filterOption={(inputValue, option) => {
                        if (option.children) {
                          return (
                            option.children
                              .toLowerCase()
                              .indexOf(inputValue.toLowerCase()) >= 0
                          );
                        }
                      }}
                    >
                      {this.driverLoginStore?.getDrivers?.map((val) => {
                        return <Option value={val.driverId}>{val.name}</Option>;
                      })}
                    </Select>
                  </>
                )}

                <RangePicker
                  placeholder={[
                    this.context.translate("_FROM_DATE_TIME_"),
                    this.context.translate("_TO_DATETIME_"),
                  ]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 380 }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  disabledDate={(current) => {
                    return current && current > dayjs();
                  }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [dayjs().startOf("day"), dayjs()],
                  }}
                  defaultValue={[dayjs().startOf("day"), dayjs()]}
                />

                <Select
                  allowClear={true}
                  placeholder="Status"
                  style={{ width: 130 }}
                  onChange={async (val) => {
                    await this.setState({ status: val });
                    await this.dailyJobReportStore.loadData({
                      offset: 0,
                      limit: this.state.pageSize,
                      companyId: this.state.companyId,
                      filterBy: this.state.filterby,
                      vehicleId: this.state.selectedVehicles,
                      driverId: this.state.selectedDrivers,
                      status: val,
                      fromDate: this.state.fromDate,
                      toDate: this.state.toDate,
                      pageNo: this.state.currentPage,
                    });
                    await this.setState({ pageSize: 50, currentPage: 1 });
                    this.setState({ loading: false });
                  }}
                  options={[
                    {
                      label: "All",
                      value: "",
                    },
                    {
                      label: "Delivered",
                      value: "3",
                    },
                    {
                      label: "Pending",
                      value: "9",
                    },
                    {
                      label: "Cancelled",
                      value: "4",
                    },
                  ]}
                />

                <Button
                  type="primary"
                  onClick={async () => {
                    await this.setState({ pageSize: 50, currentPage: 1 });
                    await this.showData();
                  }}
                >
                  {/* Show */}
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
              </Space>
            </Col>
            <Col span={4}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              ></Space>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.dailyJobReportStore?.total}
            columns={this.state.column}
            dataSource={this.dailyJobReportStore?.detailedJobData}
            loading={this.dailyJobReportStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>
      </>
    );
  }
}
DailyJobReport.contextType = StoreContext;
export default observer(withRouter(DailyJobReport));
